import React, { useEffect } from 'react'
import type { CSSProperties } from 'react'
import styles from './index.module.css'

declare global {
  interface Window {
    adsbygoogle: any[]
  }
}

interface AdBannerProps {
  adSlot: string
  adFormat?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal'
  fullWidthResponsive?: boolean
  style?: CSSProperties
}

const AdBanner = ({
  adSlot,
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = { display: 'block' },
}: AdBannerProps) => {
  const adClient = process.env.NEXT_PUBLIC_GOOGLE_AD_SENSE_ID

  useEffect(() => {
    if (!adClient || !adSlot) return

    try {
      if (typeof window !== 'undefined') {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      }
    } catch (err: any) {
      console.error('AdSense error:', err.message)
    }
  }, [adSlot, adClient])

  if (!adClient) {
    return null
  }

  return (
    <div className={styles.container}>
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  )
}
AdBanner.displayName = 'AdBanner'

export default AdBanner
